var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"description text-left"},[_c('Truncate',[_c('HTMLContent',{staticClass:"description__content",attrs:{"content":_vm.descriptionHtml}})],1),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }